var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-date-picker',{attrs:{"type":"month","multiple":"","color":"primary"},model:{value:(_vm.months),callback:function ($$v) {_vm.months=$$v},expression:"months"}})}
var staticRenderFns = []

export { render, staticRenderFns }